module.exports = __webpack_public_path__ + "img/obrigado-15k.8317940c.png";